(() => {
  'use strict';
  function openTarget(hash, moveFocus = false) {
    if (!hash || hash.charAt(0) !== '#') return null;
    let id;
    try { id = decodeURIComponent(hash.slice(1)); } catch (_) { return null; }
    const target = document.getElementById(id);
    if (!target) return null;
    let node = target;
    while (node) {
      const details = node.matches('details') ? node : node.closest('details');
      if (!details) break;
      details.open = true;
      node = details.parentElement;
    }
    if (moveFocus) {
      const focusTarget = target.matches('details') ? target.querySelector('summary') : target;
      if (focusTarget) {
        if (!focusTarget.matches('summary, a, button, input, select, textarea, [tabindex]')) focusTarget.setAttribute('tabindex', '-1');
        focusTarget.focus({ preventScroll: true });
      }
      target.scrollIntoView({ block: 'start', behavior: 'instant' });
    }
    return target;
  }
  document.addEventListener('click', (event) => {
    if (event.defaultPrevented || event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
    const link = event.target.closest('a[data-aonsk-open-details][href^="#"]');
    if (!link) return;
    const hash = link.getAttribute('href');
    if (!openTarget(hash, true)) return;
    event.preventDefault();
    if (window.location.hash !== hash) window.history.pushState(null, '', hash);
  });
  window.addEventListener('hashchange', () => openTarget(window.location.hash, true));
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => openTarget(window.location.hash), { once: true });
  else openTarget(window.location.hash);
})();
